import React from 'react';
import PropTypes from 'prop-types';
import FetchSelect from '../../../core/form/FetchSelect';
import RangeDateInput from '../../../core/form/RangeDateInput';
import Card from '../../../core/layout/Card';
import Column from '../../../core/layout/Column';
import PermissionValidator from '../../../core/layout/PermissionValidator';
import Row from '../../../core/layout/Row';
import { Roles } from '../../../core/util';
import Button from '../../../core/form/Button';
import { get } from 'lodash';

export default function PlacementTestReportFilter(props) {
  return (
    <Card title="Report filters">
      <Row>
        <PermissionValidator allowedFor={[Roles.ADMIN, Roles.SUPPORT, Roles.DISTRIBUTOR_MANAGER]}>
          <Column size={2.5}>
            <FetchSelect
              url="/companies"
              showSearch={true}
              disabled={false}
              multiple={true}
              label="Companies"
              value={props.values.companies}
              onChange={(value) => {
                if (value.length < props.values.companies.length) {
                  props.onChange('schools', []);
                  props.onChange('schoolClasses', []);
                }
                props.onChange('companies', value);
              }}
              placeholder="Select Companies"
              resultTransformer={{
                text: 'name',
                value: 'id',
              }}
            />
          </Column>
        </PermissionValidator>
        <PermissionValidator
          allowedFor={[Roles.ADMIN, Roles.SUPPORT, Roles.DISTRIBUTOR_MANAGER, Roles.COMPANY_MANAGER]}
        >
          <Column size={2.5}>
            <FetchSelect
              showSearch={true}
              isPaginated={true}
              multiple={true}
              url="/schools"
              params={{
                company: { $in: get(props.values, 'companies', []) },
              }}
              disabled={get(props.values, 'companies', []).length === 0}
              label="Schools"
              value={props.values.schools}
              onChange={(value) => {
                if (value.length < props.values.schools.length) {
                  props.onChange('schoolClasses', []);
                }
                props.onChange('schools', value);
              }}
              placeholder="Select Schools"
              resultFilter={(school) =>
                get(props.values, 'companies', []).some((companyId) => companyId === get(school, 'company.id'))
              }
              resultTransformer={{
                text: 'name',
                value: 'id',
              }}
            />
          </Column>
        </PermissionValidator>
        <Column size={2.5}>
          <FetchSelect
            showSearch={true}
            isPaginated={true}
            multiple={true}
            url="/classes"
            params={{
              school: { $in: get(props.values, 'schools', []) },
            }}
            disabled={!get(props.values, 'schools', []).length}
            label="School Classes"
            value={get(props.values, 'schoolClasses', [])}
            onChange={(value) => props.onChange('schoolClasses', value)}
            placeholder="Select School Classes"
            resultTransformer={{
              text: 'name',
              value: 'id',
            }}
          />
        </Column>
        <Column size={2.5}>
          <RangeDateInput
            label="Report Period"
            disabled={false}
            onChange={(dates) => {
              props.onChange('periodStart', dates[0]);
              props.onChange('periodEnd', dates[1]);
            }}
            placeholder={['From', 'To']}
            value={[get(props.values, 'periodStart', undefined), get(props.values, 'periodEnd', undefined)]}
          />
        </Column>
        <Column size={2}>
          <div style={{ marginTop: '43px' }}>
            <Button label="Search" icon="search" onClick={props.onSearch} />
          </div>
        </Column>
      </Row>
    </Card>
  );
}

PlacementTestReportFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  values: PropTypes.object,
};

PlacementTestReportFilter.defaultProps = {
  values: {},
};
